import clsx from 'clsx'
import PropTypes from 'prop-types'

import { useAvatarUrl } from '../../shared/useAvatarUrls'

import styles from './style.module.scss'

/**
 * Das Titelbild einer Nachricht — überall im selben Ausschnitt.
 *
 * Hochgeladen wird auf 16:9 zugeschnitten (siehe `UI/CoverUploader`), gezeigt
 * wird es in derselben Form: auf der Karte, in der Spalte neben den Mitteilungen
 * und über dem Text im Fenster. Ein Bild, das je nach Ansicht anders
 * beschnitten ist, lässt dieselbe Nachricht zweimal verschieden aussehen.
 *
 * Geholt wird es angemeldet (`shared/useAvatarUrls`) — ein `<img src="…">`
 * schickt keinen Anmelde-Kopfeintrag mit, und die Bild-Route antwortet nur
 * Angemeldeten.
 *
 * Ohne Bild kommt nichts: Die Nachricht ohne Titelbild ist der Normalfall, ein
 * leerer Platzhalter wäre an jeder Karte eine graue Fläche ohne Aussage.
 * Solange das Bild lädt, steht die Fläche aber schon da — sonst springt die
 * Karte, wenn es ankommt.
 */
export default function NewsCover({ hashName, alt = '', className }) {
	const url = useAvatarUrl(hashName)

	if (!hashName) return null

	return (
		<div className={clsx(styles.cover, className)}>
			{!!url && <img className={styles.image} src={url} alt={alt} />}
		</div>
	)
}

NewsCover.propTypes = {
	/** Dateiname aus `imageHashName` der Nachricht. */
	hashName: PropTypes.string,
	alt: PropTypes.string,
	className: PropTypes.string
}
